import { TextField, styled, Popper } from '@mui/material';
import React, { FC } from 'react';
import Autocomplete, { autocompleteClasses } from '@mui/material/Autocomplete';
import ListboxComponent from './VirtualizedListbox';

interface GenericPeopleOption {
  id: string;
  fullName: string;
  firstName?: string;
  middleName?: string;
  lastName?: string;
  email?: string;
}
interface GenericPeopleDropdownProps {
  label: string;
  options: GenericPeopleOption[];
  selectedOptions: GenericPeopleOption[];
  onChange: (selected: GenericPeopleOption[]) => void;
  disabled?: boolean;
  isChildren?: boolean;
}
const StyledPopper = styled(Popper)({
  [`& .${autocompleteClasses.listbox}`]: {
    boxSizing: 'border-box',
    '& ul': { padding: 0, margin: 0 }
  }
});

const GenericPeopleDropdown: FC<GenericPeopleDropdownProps> = ({
  label,
  options,
  selectedOptions,
  onChange,
  disabled = false,
  isChildren = false
}) => {
  return (
    <Autocomplete
      multiple
      options={options}
      disableCloseOnSelect
      disabled={disabled}
      getOptionLabel={option => `${option.fullName} `}
      value={selectedOptions}
      onChange={(_, v) => onChange(v)}
      filterOptions={(options, state) => {
        const input = state.inputValue.toLowerCase().trim();

        return options.filter(opt => {
          if (isChildren) {
            const first = (opt.firstName ?? '').toLowerCase();
            const middle = (opt.middleName ?? '').toLowerCase();
            const last = (opt.lastName ?? '').toLowerCase();
            const full = `${first} ${middle} ${last}`.replace(/\s+/g, ' ').trim();

            return (
              full.includes(input) ||
              `${first} ${last}`.includes(input) ||
              `${last} ${first}`.includes(input) ||
              first.includes(input) ||
              last.includes(input)
            );
          }

          return opt.fullName.toLowerCase().includes(input);
        });
      }}
      renderOption={(props, option, state) => [props, option, state] as unknown as React.ReactNode}
      renderInput={params => <TextField {...params} label={label} placeholder="Search..." disabled={disabled} />}
      slots={{ popper: StyledPopper }}
      sx={{ width: '100%' }}
      slotProps={{ listbox: { component: ListboxComponent } as any }}
    />
  );
};

export default GenericPeopleDropdown;
